import React from 'react'
import { useCreditCardButton } from 'modules/payment'

import type { ButtonProps } from 'components/inputs'
import { Button } from 'components/inputs'

import usePayButtonInfoFromInquire from '../util/usePayButtonInfoFromInquire'


export type CreditCardButtonProps = Omit<ButtonProps, 'onClick'> & {
  disabled?: boolean
}

const CreditCardButton: React.FunctionComponent<CreditCardButtonProps> = (props) => {
  const { submitCreditCard, isProcessing } = useCreditCardButton()

  const { defaultTitle, isInquireFetching } = usePayButtonInfoFromInquire()

  return (
    <Button
      loading={isInquireFetching}
      title={defaultTitle}
      {...props}
      disabled={isProcessing || props.disabled}
      onClick={submitCreditCard}
      data-testid="creditCardButton"
    />
  )
}


export default CreditCardButton
